// Matches the backend default WS_MAX_SYMBOLS_PER_CLIENT.
export const MAX_LIVE_QUOTE_SYMBOLS = 1000;

const normalizeSymbols = (symbols) => [...new Set(
  (symbols || []).map((symbol) => String(symbol || '').trim().toUpperCase()).filter(Boolean)
)].sort();

// Subscribe to every active symbol so paging/filtering never waits for a resubscribe.
// Visible symbols are always kept when the list exceeds the server's per-client limit.
export const buildLiveQuoteSubscription = (visibleSymbols, allSymbols, limit = MAX_LIVE_QUOTE_SYMBOLS) => {
  const visible = normalizeSymbols(visibleSymbols);
  const all = normalizeSymbols([...visible, ...(allSymbols || [])]);
  if (all.length <= limit) return all;

  const visibleSet = new Set(visible);
  const remaining = all.filter((symbol) => !visibleSet.has(symbol));
  return [...visible, ...remaining].slice(0, limit).sort();
};
